export default __webpack_public_path__ + "static/media/23t.260074a8.jpg";